enum BroadcastChannelName {
  ThermostatRedirect = 'thermostat-redirect',
  GridSupport = 'GridSupport',
}

export default BroadcastChannelName
